/**
 * Designed  & Developed by Faisal Nadaf
 * Contact: faisalfnadaf@gmail.com
 *
 * @format
 */

import { useTranslation } from "react-i18next";
import { Navigation } from "@/components/customCopmonent/landingSection/navigation";
import { FooterSection } from "@/components/customCopmonent/landingSection/footer-section";
import {
	PageShell,
	SectionDivider,
	SectionWrapper,
} from "./VisionMission.page-primitives";
import DotGrid from "@/components/customCopmonent/DotGrid";
import { PageHeaderHero, PAGE_HERO_CLASS } from "@/components/customCopmonent/Text/PageHeaderHero";
import VisionMissionSection from "@/components/customCopmonent/VisionMissionSection";
import Seo from "@/components/Seo";

const bgimage = "/images/headerPhotos/mission-vision-banner-photo.webp";

const visionVideo =
	"https://res.cloudinary.com/dcacqhspd/video/upload/v1776959671/llcdjvbltjrgbltzwh2j.mp4";

// Mission card images, kept in fixed order; text resolves from the locale.
const missionImages = [
	"/images/headerPhotos/C2628T01.JPG",
	"/images/headerPhotos/DSC09194.JPG",
	"/images/headerPhotos/DSC09153.JPG",
	"/images/freeDownloads/VisionMission/PrincipledGrowth.jpg",
];

const VisionMission = () => {
	const { t } = useTranslation();

	const meta = t("aboutPages.visionMission.meta", {
		returnObjects: true,
	}) as string[];

	const missionPoints = (
		t("aboutPages.visionMission.mission.points", {
			returnObjects: true,
		}) as { title: string; description: string }[]
	).map((point, index) => ({
		...point,
		image: missionImages[index] ?? "",
	}));

	const data = {
		vision: {
			title: t("aboutPages.visionMission.vision.title"),
			image: visionVideo,
			content: t("aboutPages.visionMission.vision.content"),
		},
		mission: {
			title: t("aboutPages.visionMission.mission.title"),
			intro: t("aboutPages.visionMission.mission.intro"),
			points: missionPoints,
		},
	};

	return (
		<PageShell>
			<Seo
				titleKey="aboutPages.visionMission.seo.title"
				descriptionKey="aboutPages.visionMission.seo.description"
				path="/vision-mission"
			/>
			<Navigation />
			{/* HEADER */}
			<SectionWrapper className={PAGE_HERO_CLASS}>
				<div className="absolute inset-0 ">
					<div
						className="absolute bottom-3 inset-0 opacity-35 scale-105"
						style={{
							backgroundImage: `url(${bgimage})`,
							backgroundSize: "cover",
							backgroundPosition: "center",
						}}
					/>
					<DotGrid
						dotSize={4}
						gap={15}
						baseColor="#3b0092"
						activeColor="#f09a38"
						proximity={100}
						shockRadius={200}
						shockStrength={3}
						resistance={750}
						returnDuration={1.5}
					/>
				</div>
				<PageHeaderHero
					title={t("aboutPages.visionMission.title")}
					description={t("aboutPages.visionMission.tagline")}
					meta={meta}
				/>
			</SectionWrapper>
			<SectionDivider />

			{/* CALL THE COMPONENT HERE */}
			<VisionMissionSection data={data} />

			<FooterSection />
		</PageShell>
	);
};

export default VisionMission;
